import "./FormComponents.css"

export default function NotRequired() {
  return <p className="not-required">* not required</p>;
}
